import React from 'react';
import { Card, Text, Badge, Group, Button, Stack, Image, ActionIcon, Menu } from '@mantine/core';
import { IconDownload, IconEye, IconTrash, IconDotsVertical, IconCalendar, IconMapPin } from '@tabler/icons-react';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';

/**
 * EudrReportCard Component
 * 
 * Displays a single EUDR report with actions
 */
const EudrReportCard = ({ report, onView, onDownload, onDelete }) => {
  const intl = useIntl();

  return (
    <Card shadow="sm" p="lg" radius="md" withBorder>
      <Stack spacing="sm">
        {/* Header */}
        <Group position="apart">
          <Text weight={600} size="lg">
            {report.fieldName}
          </Text>
          <Menu position="bottom-end" shadow="md">
            <Menu.Target>
              <ActionIcon>
                <IconDotsVertical size={16} />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item 
                icon={<IconEye size={14} />}
                onClick={() => onView(report)}
              >
                <FormattedMessage id="eudr.report.view" defaultMessage="View Details" />
              </Menu.Item>
              <Menu.Item 
                icon={<IconDownload size={14} />}
                onClick={() => onDownload(report)}
              >
                <FormattedMessage id="eudr.report.download" defaultMessage="Download Report" />
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item 
                icon={<IconTrash size={14} />}
                color="red"
                onClick={() => onDelete(report)}
              >
                <FormattedMessage id="eudr.report.delete" defaultMessage="Delete" />
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>

        {/* Report Info */}
        <Group spacing="xs">
          <IconCalendar size={16} />
          <Text size="sm" color="dimmed">
            {moment(report.generatedAt).format('DD-MM-YYYY HH:mm')}
          </Text>
        </Group>

        <Group spacing="xs">
          <IconMapPin size={16} />
          <Text size="sm" color="dimmed">
            {report.location?.latitude?.toFixed(4)}, {report.location?.longitude?.toFixed(4)}
          </Text>
        </Group>

        {/* Image Count Badge */}
        <Group>
          <Badge color="blue" variant="light">
            {report.imageCount} <FormattedMessage id="eudr.report.images" defaultMessage="images" />
          </Badge>
          <Badge color="green" variant="light">
            {report.datesIncluded?.length || 0} <FormattedMessage id="eudr.report.dates" defaultMessage="dates" />
          </Badge>
        </Group>

        {/* Actions */}
        <Group position="apart" mt="md">
          <Button 
            variant="light" 
            color="blue"
            leftIcon={<IconEye size={16} />}
            onClick={() => onView(report)}
          >
            <FormattedMessage id="eudr.report.view" defaultMessage="View Details" />
          </Button>
          <Button 
            variant="outline" 
            color="green"
            leftIcon={<IconDownload size={16} />}
            onClick={() => onDownload(report)}
          >
            <FormattedMessage id="eudr.report.download" defaultMessage="Download" />
          </Button>
        </Group>
      </Stack>
    </Card>
  );
};

export default EudrReportCard;
